import React from 'react';

import { Icon } from '@chakra-ui/react';

export const AzureEntraConnectIcon = props => (
  <Icon viewBox="0 0 18 18" w="full" h="full" color="inherit" {...props}>
    <defs>
      <linearGradient
        id="uuid-715a95c6-dbaa-4220-8878-769f414e4d1c"
        x1="7.669"
        y1="779.631"
        x2="14.031"
        y2="787.067"
        gradientTransform="translate(0 791.516) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#225086" />
        <stop offset="1" stop-color="#0055c5" />
      </linearGradient>
      <linearGradient
        id="uuid-8bed8a34-40e3-45ff-96f5-3f4e39a2709b"
        x1="6.341"
        y1="778.631"
        x2="6.341"
        y2="794.82"
        gradientTransform="translate(0 791.516) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#6df" />
        <stop offset="1" stop-color="#0294e4" />
      </linearGradient>
      <linearGradient
        id="uuid-7670c307-67cb-4bb8-aa08-22886e397611"
        x1="8.968"
        y1="776.431"
        x2="8.968"
        y2="795.251"
        gradientTransform="translate(0 791.516) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#44dbf9" />
        <stop offset="1" stop-color="#cbf8ff" />
      </linearGradient>
      <linearGradient
        id="uuid-5ebc116c-2b44-4077-8e82-3744bdc1ef1c"
        x1="13.451"
        y1="775.2"
        x2="13.451"
        y2="791.203"
        gradientTransform="translate(0 791.516) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0" stop-color="#041642" />
        <stop offset="1" stop-color="#041642" stop-opacity=".25" />
      </linearGradient>
      <linearGradient
        id="uuid-ea0a50d3-a0ed-4236-88d2-db9ecc2f6a18"
        x1="-550.516"
        y1="1008.032"
        x2="-550.516"
        y2="1017.064"
        gradientTransform="translate(564 1025.516) scale(1 -1)"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset=".001" stop-color="#773adc" />
        <stop offset=".342" stop-color="#8b55e6" />
        <stop offset=".756" stop-color="#9f70f0" />
        <stop offset="1" stop-color="#a67af4" />
      </linearGradient>
    </defs>
    <g>
      <path
        d="m17.583,9.451L10.11,1.022c-.597-.674-1.688-.674-2.286,0L.352,9.451c-.577.652-.426,1.635.322,2.103l7.472,4.671c.498.312,1.144.312,1.642,0l7.472-4.671c.748-.467.899-1.452.322-2.103h0Z"
        fill="url(#uuid-715a95c6-dbaa-4220-8878-769f414e4d1c)"
        stroke-width="0"
      />
      <path
        d="m10.111,1.022c-.597-.674-1.688-.674-2.286,0L.353,9.451c-.577.652-.426,1.635.322,2.103,0,0,2.766,1.729,3.115,1.947.387.241,1.029.509,1.709.509.619,0,1.193-.179,1.67-.485,0,0,0,0,.002,0l1.798-1.124-4.348-2.718,4.458-5.029c.548-.625,1.372-1.022,2.294-1.022.47,0,.914.107,1.309.291l-2.57-2.899v-.002Z"
        fill="url(#uuid-8bed8a34-40e3-45ff-96f5-3f4e39a2709b)"
        stroke-width="0"
      />
      <polygon
        points="4.619 9.683 4.671 9.714 8.968 12.401 8.968 12.401 13.316 9.683 13.317 9.683 13.316 9.683 8.968 4.776 4.619 9.683"
        fill="url(#uuid-7670c307-67cb-4bb8-aa08-22886e397611)"
        stroke-width="0"
      />
      <path
        d="m8.968,16.459c.286,0,.572-.078.821-.233l7.472-4.671c.748-.467.899-1.452.322-2.103L10.111,1.022c-.299-.337-.72-.505-1.143-.505v15.943Z"
        fill="url(#uuid-5ebc116c-2b44-4077-8e82-3744bdc1ef1c)"
        fill-opacity=".5"
        //isolation="isolate"
        opacity=".5"
        stroke-width="0"
      />
    </g>
    <circle
      cx="13.484"
      cy="12.968"
      r="4.516"
      fill="url(#uuid-ea0a50d3-a0ed-4236-88d2-db9ecc2f6a18)"
      stroke-width="0"
    />
    <path
      d="m15.257,12.36h-.689c-.224.004-.404.188-.4.413.003.219.181.397.4.4h1.49c.224,0,.406-.182.406-.407v-1.761c.004-.224-.176-.409-.4-.413s-.409.176-.413.4c0,.004,0,.009,0,.013v.406c-.511-.683-1.315-1.084-2.168-1.084-.8-.008-1.562.345-2.074.96-.141.175-.114.431.06.572.171.139.422.115.565-.052.358-.429.89-.674,1.449-.666.787,0,1.492.485,1.773,1.219Z"
      fill="#fff"
      stroke-width="0"
    />
    <path
      d="m11.317,15.07v-.406c.901,1.199,2.604,1.44,3.803.539.16-.12.306-.258.436-.41.145-.171.125-.428-.046-.573-.171-.145-.428-.125-.573.046h0c-.681.8-1.882.896-2.682.215-.204-.174-.369-.388-.484-.63h.63c.224.004.409-.176.413-.4s-.176-.409-.4-.413c-.004,0-.009,0-.013,0h-1.491c-.224,0-.406.182-.406.406h0v1.626c-.004.224.176.409.4.413s.409-.176.413-.4c0-.004,0-.009,0-.013h0Z"
      fill="#fff"
      stroke-width="0"
    />
  </Icon>
);
